export default __webpack_public_path__ + "static/media/faten.73394b5a.png";